<template>
  <div class="form-group">
    <label class="control-label col-md-3 col-sm-3 col-xs-12">{{ title }}</label>
    <div class="col-md-9 col-sm-9 col-xs-12">
      <select
        class="form-control"
        :class="{ 'is-invalid': error }"
        :name="name"
        :value="value"
        @change="$emit('change', $event.target.value)"
      >
        <slot></slot>
      </select>

      <div v-if="error" class="invalid-feedback">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      error: String,
      value: String,
      name: String,
      title: String
    }
  }
</script>
